// Countries allowed to access the site
// Uses ISO 3166-1 alpha-2 country codes
// Reference: https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2

export const ALLOWED_COUNTRIES = [
  'US', // United States
  'PR', // Puerto Rico
  'VI', // US Virgin Islands
  'GU', // Guam
  'AS', // American Samoa
  'MP', // Northern Mariana Islands
];

export const isCountryBlocked = (countryCode) => {
  if (!countryCode) return false; // Allow if geolocation fails (fail open)
  return !ALLOWED_COUNTRIES.includes(countryCode.toUpperCase());
};
